import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";

const YOUTUBE_PLAYLIST_URL = process.env.REACT_APP_YOUTUBE_PLAYLIST_URL;

const SECTIONS = [
  {
    title: "Podcast Episodes",
    copy: "Conversations with writers, artists, speakers, and cultural leaders.",
    to: "/podcast",
    cta: "Browse the Archive →",
    testId: "sc-podcast",
  },
  {
    title: "Journal & Essays",
    copy: "Editorial writing on story, craft, culture, and public life.",
    to: "/blog",
    cta: "Read the Journal →",
    testId: "sc-blog",
  },
  {
    title: "Literary Projects",
    copy: "Anthologies, journals, and print publications in development.",
    to: "https://theathenaeumpress.com/projects/write-home-letters-to-a-younger-me/",
    cta: "WRITE HOME Anthology →",
    testId: "sc-literary",
  },
  {
    title: "Theater & Performance",
    copy: "Story slams, stage work, and performance projects in development.",
    to: YOUTUBE_PLAYLIST_URL,
    cta: "Watch on YouTube →",
    testId: "sc-theater",
  },
  {
    title: "Exhibitions",
    copy: "Seen/Unseen — a collaborative exhibition with Kara Gunter at Emergent Arts, built from the images and words of community volunteers living with illness, cancer, chronic conditions, and disability.",
    to: "https://emergentarts.wildapricot.org/",
    cta: "Seen/Unseen at Emergent Arts →",
    testId: "sc-exhibitions",
  },
  {
    title: "Community Storytelling",
    copy: "Story circles, workshops, and collaborations — including testifier coaching with WREN to bring more South Carolina voices to the statehouse.",
    to: "/stories-move",
    cta: "Explore Stories Move →",
    testId: "sc-community",
  },
];

const StoriesCulturePage = () => {
  return (
    <>
      <Seo
        title="Stories & Culture — #whatshesaidproject"
        description="The editorial home of #whatshesaidproject: podcast episodes, essays, literary projects, theater and performance, exhibitions, and community storytelling."
        path="/stories-culture"
      />
      <section className="bg-white text-[#121212] pt-12 pb-24 md:py-28 border-b border-[#e5e5e5]">
        <div className="max-w-6xl mx-auto px-6">
          <span className="text-xs font-mono uppercase tracking-[.18em] text-[#e02020] block mb-3">
            Stories &amp; Culture
          </span>
          <h1
            data-testid="stories-culture-headline"
            className="font-disp text-[clamp(36px,5vw,72px)] leading-[1.02] tracking-tight font-normal text-[#121212] text-balance max-w-4xl mb-6"
          >
            The editorial home of the work.
          </h1>
          <p className="text-[17px] leading-[1.65] text-[#555555] max-w-2xl">
            Podcast episodes, essays, literary projects, theater and performance, exhibitions, and
            community storytelling — one archive, still taking shape.
          </p>
        </div>
      </section>

      <section className="bg-[#fafafa] text-[#121212] py-24 md:py-32">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {SECTIONS.map((s) => (
              <article
                key={s.testId}
                data-testid={`stories-culture-card-${s.testId}`}
                className="bg-white border border-[#e5e5e5] hover:border-[#121212] transition-colors p-8 md:p-10 flex flex-col justify-between"
              >
                <div>
                  <h2 className="font-disp text-2xl text-[#121212] mb-3">{s.title}</h2>
                  <p className="text-sm text-[#555555] leading-relaxed mb-8">{s.copy}</p>
                </div>
                {s.placeholder ? (
                  <span className="text-xs font-mono uppercase tracking-[.14em] text-[#6b6b6b]">
                    Placeholder — in development
                  </span>
                ) : s.to.startsWith("http") ? (
                  <a
                    href={s.to}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`${s.testId}-link`}
                    className="inline-flex items-center text-xs font-mono uppercase tracking-[.14em] text-[#121212] font-semibold underline underline-offset-4 hover:text-[#e02020] transition-colors"
                  >
                    {s.cta}
                  </a>
                ) : (
                  <Link
                    to={s.to}
                    data-testid={`${s.testId}-link`}
                    className="inline-flex items-center text-xs font-mono uppercase tracking-[.14em] text-[#121212] font-semibold underline underline-offset-4 hover:text-[#e02020] transition-colors"
                  >
                    {s.cta}
                  </Link>
                )}
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default StoriesCulturePage;
